import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import DateHelper from '../../helpers/DateHelper';
import MUIModal from '../shared/MUIModal';
import MUIModalButtonStyles from '../shared/MUIStyles/MUIModalButtonStyles';
import { Button } from '@mui/material';

const UserEmails = ({
    user,
    secondaryEmail,
    onOpenModal,
    onCloseModal,
    onRemove,
    modals,
    onSave,
    onChange,
    isValid,
    localized
}) => {
    return (
        <div className="subemail flex" style={{ flexDirection: 'row', gap: '2rem' }}>
            {/* Primary Email */}
            <div className="email-section">
                <div className="label text">{localized.Primary}</div>
                <div className="email">{user.email}</div>
            </div>

            {/* Secondary Email */}
            <div className="email-section">
                <div className="label text">{localized.Secondary}</div>
                <div className="email">{user.secondaryEmail || '—'}</div>
                <div className="button-row" style={{ display: 'flex', gap: '1rem', marginTop: '0.5rem' }}>
                    <button className="button link" onClick={onOpenModal}>
                        {user.secondaryEmail ? localized.Edit : localized.Add} {localized.SecondaryEmail}
                    </button>
                    {user.secondaryEmail && (
                        <div className="button-wrapper">
                    <button className="remove" onClick={onRemove}>
                      <span>X </span><span>{localized.Remove}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Last Login */}
            <div className="email-section">
                <div className="label text">{localized.LastLogin}</div>
                <div className="email">
                    {user.lastActivity
                        ? DateHelper.format(new Date(user.lastActivity), 'MM/dd/yyyy hh:mm a', true)
                        : '—'}
                </div>
            </div>
                <MUIModal
                open={modals.secondaryEmail}
                onClose={onCloseModal}
                title={user.secondaryEmail ? localized.Edit : localized.Add +' '+ localized.SecondaryEmail}
                    maxWidth="sm"
                    showDefaultButtons={false}               
                customActions={
                    <>
                        <Button
                            type="button"
                            onClick={onCloseModal}
                            sx={MUIModalButtonStyles}
                        >
                            {localized.Cancel}
                        </Button>
                        <Button
                            type="button"
                            onClick={onSave}
                            sx={MUIModalButtonStyles}
                        >
                            {localized.Save}
                        </Button>
                    </>
                }
                >
                <Container>
                    <Row>
                        <Col xs={1}></Col>
                        <Col xs={6} md={10}>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    className="input-secondary-email"
                                    onChange={onChange}
                                    value={secondaryEmail || ''}
                                />
                            </div>
                        </Col>
                    </Row>
                    {!isValid && (
                        <Row>
                            <Col xs={1}></Col>
                            <Col xs={8}>
                                <div className="invalid-email-message">
                                    {localized.InvalidEmailMessage}
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <div style={{ color: '#848484', fontWeight: '500', lineHeight: '21px' }}>
                            {localized.Body}
                        </div>
                    </Row>
                </Container>
            </MUIModal>
        </div>
    );
};

UserEmails.propTypes = {
    user: PropTypes.object.isRequired,
    secondaryEmail: PropTypes.string.isRequired,
    onOpenModal: PropTypes.func.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    modals: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isValid: PropTypes.bool.isRequired,
    localized: PropTypes.object.isRequired
};

export default UserEmails;
